import classNames from 'classnames';
import React from 'react';

import { AccountIcon, ArrowDownIcon } from '@app/components/icons';
import { LogoutButton } from '@app/components/logout-button';

export const DesktopUtilityNav = ({ auth, authText }) => {
	const {
		myCoursesUrl,
		myGradesUrl,
		myOrderHistoryUrl,
		progressTrackerUrl,
		logoutUrl,
		memberSite,
		loginUrl,
		isAuthenticated,
	} = auth;

	return (
		<li
			className={classNames('u-hidden-tablet-max', 'utility-nav__item', {
				'flyout__container': isAuthenticated,
				'flyout__container--on-hover': isAuthenticated,
			})}
		>
			{!isAuthenticated ? (
				<a
					href={loginUrl}
					className="u-text-uppercase utility-nav__link"
					title="Sign In"
				>
					<AccountIcon className="utility-nav__icon" />
					<span className="u-text-uppercase utility-nav__label">
						{authText}
					</span>
				</a>
			) : (
				<>
					<button
						type="button"
						className="utility-nav__link utility-nav__link--btn"
					>
						<AccountIcon className="utility-nav__icon" />
						<span className="u-text-uppercase utility-nav__label">
							{authText}
							<span className="u-sr-only"> View Your Account Options</span>
							<ArrowDownIcon />
						</span>
					</button>

					<div className="flyout__panel">
						<ul className="u-list-unstyled">
							<li className="flyout__item">
								<a href="/profile" className="flyout__link">
									My Account
								</a>
							</li>
							<li className="flyout__item">
								<a href={myCoursesUrl} className="flyout__link">
									My Courses & Exams
								</a>
							</li>
							<li className="flyout__item">
								<a href={progressTrackerUrl} className="flyout__link">
									My Progress Tracker
								</a>
							</li>
							<li className="flyout__item">
								<a href={myGradesUrl} className="flyout__link">
									My Grades
								</a>
							</li>
							<li className="flyout__item">
								<a href={myOrderHistoryUrl} className="flyout__link">
									My Order History
								</a>
							</li>

							<li className="flyout__item">
								<LogoutButton logoutUrl={logoutUrl} memberSite={memberSite} />
							</li>
						</ul>
					</div>
				</>
			)}
		</li>
	);
};
